/**
 * カテゴリマスタ（デフォルト値）
 * grade=2（小カテゴリ）のみ。ソース: mall DB production（2026-03-31時点）
 * demandScore / growth はブランドライン実績から推定
 *
 * @graph-stack mall-api
 * @graph-domain Operations
 * @graph-business モール商品カテゴリのベース転換率・成長率・需要スコア・日常使用フラグマスタ。35カテゴリ
 * @graph-connects none
 */
export const DEFAULT_CATEGORIES = {
    // ── 美容家電 ──
    シャワーヘッド: { baseRate: 28.0, growth: '安定成長', demandScore: 75, dailyUse: true },
    ドライヤー: { baseRate: 18.0, growth: '成長', demandScore: 80, dailyUse: true },
    ヘアアイロン: { baseRate: 22.0, growth: '安定', demandScore: 70, dailyUse: true },
    ヘッドスパ: { baseRate: 18.0, growth: '安定', demandScore: 50, dailyUse: false },
    '美顔器・スチーマー': { baseRate: 10.0, growth: '横ばい', demandScore: 60, dailyUse: false },
    '脱毛器・光美容器': { baseRate: 14.0, growth: '安定', demandScore: 55, dailyUse: false },
    // ── ヘルスケア家電 ──
    'トレーニングマシン・器具': { baseRate: 13.0, growth: '安定', demandScore: 65, dailyUse: false },
    'マッサージガン・マッサージ機': {
        baseRate: 24.0,
        growth: '成長',
        demandScore: 60,
        dailyUse: false,
    },
    'マットレス・寝具': { baseRate: 17.0, growth: '安定', demandScore: 50, dailyUse: true },
    // ── リカバリーウェア ──
    リカバリーウェア: { baseRate: 22.0, growth: '成長', demandScore: 45, dailyUse: true },
    // ── オーディオ機器 ──
    'イヤホン・ヘッドホン': { baseRate: 10.0, growth: '横ばい', demandScore: 40, dailyUse: true },
    スピーカー: { baseRate: 15.0, growth: '横ばい', demandScore: 40, dailyUse: true },
    // ── キッチン家電 ──
    オーブントースター: { baseRate: 30.0, growth: '横ばい', demandScore: 40, dailyUse: true },
    コーヒーメーカー: { baseRate: 0.0, growth: '横ばい', demandScore: 35, dailyUse: true },
    ホットプレート: { baseRate: 10.0, growth: '横ばい', demandScore: 35, dailyUse: false },
    炊飯器: { baseRate: 10.0, growth: '横ばい', demandScore: 40, dailyUse: true },
    炭酸水メーカー: { baseRate: 12.5, growth: '横ばい', demandScore: 40, dailyUse: true },
    '生ごみ処理機・生ごみ乾燥機': {
        baseRate: 15.8,
        growth: '横ばい',
        demandScore: 35,
        dailyUse: true,
    },
    '電気圧力鍋・自動調理鍋・鍋': {
        baseRate: 5.8,
        growth: '横ばい',
        demandScore: 45,
        dailyUse: true,
    },
    '電子レンジ・オーブンレンジ': {
        baseRate: 10.0,
        growth: '横ばい',
        demandScore: 45,
        dailyUse: true,
    },
    電気ポット: { baseRate: 10.0, growth: '横ばい', demandScore: 35, dailyUse: true },
    '食洗機・食器洗い乾燥機': { baseRate: 0.0, growth: '横ばい', demandScore: 40, dailyUse: true },
    // ── 掃除家電 ──
    '掃除機・ロボット掃除機': { baseRate: 8.0, growth: '安定', demandScore: 55, dailyUse: true },
    // ── 生活家電 ──
    '空気清浄機・加湿器・除湿器': { baseRate: 11.0, growth: '安定', demandScore: 50, dailyUse: true },
    プロジェクター: { baseRate: 10.0, growth: '横ばい', demandScore: 40, dailyUse: false },
    スマートウォッチ: { baseRate: 0.0, growth: '横ばい', demandScore: 40, dailyUse: true },
    スーツケース: { baseRate: 1.3, growth: '横ばい', demandScore: 35, dailyUse: false },
    '双眼鏡・距離計': { baseRate: 10.8, growth: '横ばい', demandScore: 30, dailyUse: false },
    'カメラ・アクションカメラ': { baseRate: 3.0, growth: '横ばい', demandScore: 40, dailyUse: false },
    ペット用品: { baseRate: 30.0, growth: '成長', demandScore: 40, dailyUse: true },
    衣類スチーマー: { baseRate: 10.0, growth: '横ばい', demandScore: 40, dailyUse: false },
    電動歯ブラシ: { baseRate: 10.0, growth: '横ばい', demandScore: 45, dailyUse: true },
    // ── ベビー用品 ──
    ベビーカー: { baseRate: 5.0, growth: '横ばい', demandScore: 35, dailyUse: true },
    ベビーカー用品: { baseRate: 5.0, growth: '横ばい', demandScore: 30, dailyUse: true },
    // ── フォールバック ──
    その他: { baseRate: 10.0, growth: '不明', demandScore: 40, dailyUse: false },
};
//# sourceMappingURL=categories.js.map